import { PosterProject } from "./poster-project";
import { defaultSizeOption } from "./default-project-style";

export const migrateProject = (project: PosterProject): PosterProject => {
  let migrated = migrateSizeOption(project);
  return migrated;
};

const migrateSizeOption = (project: PosterProject): PosterProject => {
  let migrated = { ...project };

  if (migrated.sizeOption === undefined) {
    migrated.sizeOption = defaultSizeOption;
  }

  return migrated;
};
